import { render, staticRenderFns } from "./TarfHistoryList.vue?vue&type=template&id=42832ab5&scoped=true"
import script from "./TarfHistoryList.vue?vue&type=script&lang=ts"
export * from "./TarfHistoryList.vue?vue&type=script&lang=ts"
import style0 from "./TarfHistoryList.vue?vue&type=style&index=0&id=42832ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42832ab5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VList,VListItem,VListItemContent,VListItemTitle,VRow,VTextField})
